import React from "react";
import { useLocation } from "react-router";
import { Box, Grid, Stack, styled, Typography } from "@mui/material";
import {
  getLoginRedirectURL,
  useIsLoggedIn,
  useLogUserIn,
  useLogUserOut,
} from "../../hooks/auth";
import { useSelector } from "react-redux";
import { getUser } from "../../store/reducers/authSlice";
import { ReactComponent as LoopIcon } from "../../resources/images/svg/loop.svg";
import { ReactComponent as HeartIcon } from "../../resources/images/svg/heart.svg";
import { NAVIGATION } from "./HeaderNav";
import userLogo from "../../resources/images/png/header/icon-login.png";
import UniversesList from "./UniversesList";

const MenuItemLink = styled("a")(() => {
  return {
    fontFamily: "Yesevaone",
    color: "#fff",
    fontSize: 20,
    cursor: "pointer",
    textDecoration: "none",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  };
});
const Divider = styled(Box)(() => {
  return {
    backgroundColor: "#c7c4de",
    width: "100%",
    height: "2px",
  };
});

const ItemTypo = styled("a")(() => {
  return {
    fontFamily: "Branding SemiBold",
    color: "#fff",
    fontSize: 16,
  };
});

const UserContainer = styled(Grid)(({ theme }) => {
  return {
    width: "25px",
    height: "25px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "25px",
    backgroundColor: "rgba(36,38,56,.53)",
    "&:hover": {
      cursor: "pointer",
    },
  };
});

const UserTypography = styled(Typography)(({ theme }) => {
  return {
    color: "white",
    fontFamily: "Yesevaone",
    fontSize: "12px",
    pointerEvents: "none",
  };
});

const ItemContainer = styled(Box)(() => {
  return {
    display: "flex",
    gap: 15,
    alignItems: "center",
    cursor: "pointer",
  };
});

const LeftItemContainer = styled(Box)(() => {
  return {
    width: 30,
    display: "flex",
    justifyContent: "center",
  };
});

const MenuPanelContent = ({ redirect }) => {
  useLogUserIn();

  const loggedIn = useIsLoggedIn();
  const redirectUrl = getLoginRedirectURL();
  const logout = useLogUserOut();

  const user = useSelector(getUser);

  const [infoPrive, setInfoPrive] = React.useState({
    title: "Le projet Praticiens",
    href: "/public",
  });
  let location = useLocation();

  React.useEffect(() => {
    // Google Analytics
    if (location.pathname == "/public") {
      setInfoPrive({ title: "Mon espace Praticiens", href: "/" });
    }
  }, [location]);

  return (
    <Stack mx={"20px"} spacing={4}>
      <Stack spacing={2}>
        <ItemContainer>
          <LeftItemContainer>
            <UserContainer>
              {user ? (
                <UserTypography>{`${user?.prenom[0]?.toUpperCase()}${user?.nom[0]?.toUpperCase()}`}</UserTypography>
              ) : (
                <img src={userLogo} alt={"user-logo"} />
              )}
            </UserContainer>
          </LeftItemContainer>

          {user ? (
            <a
              href="https://my.inexplore.com/profil"
              target="_blank"
              style={{ color: "white", fontWeight: 700, fontSize: 20 }}
            >
              {"Mon compte"}
            </a>
          ) : (
            <a
              href={redirectUrl}
              style={{ color: "white", fontWeight: 700, fontSize: 20 }}
            >
              {"Se connecter"}
            </a>
          )}
        </ItemContainer>
      </Stack>
      {loggedIn && (
        <MenuItemLink
          key={infoPrive.title}
          href={infoPrive.href}
          sx={{
            color: "#fbf0e5",
            fontWeight: 700,
          }}
        >
          {infoPrive.title}
        </MenuItemLink>
      )}
      {loggedIn && (
        <MenuItemLink
          sx={{
            color: "#fbf0e5",
            fontWeight: 700,
          }}
          onClick={logout}
        >
          Se déconnecter
        </MenuItemLink>
      )}
      <Divider />
      <Typography
        ml={3}
        mt={1}
        sx={{
          color: "#fbf0e5",
          fontWeight: 700,
        }}
      >
        {"Nos univers"}
      </Typography>
      <UniversesList />
    </Stack>
  );
};

export default MenuPanelContent;
